import { createApp, createSSRApp, h } from 'vue';
import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router';
import createStore from './common/store/index.js';
import initialFilters from './common/filters/index.js';
import initializeRouter from './common/routers/index.js';
import $eventBus from './common/providers/eventbus.js';
import urlMixin from './common/mixins/url.js';
import vnumberMixin from './common/mixins/vnumber.js';
import compNameMixin from './common/mixins/comp.js';
import molang from './common/plugins/molang.js';
import App from './app.vue';
import { loadDebugBear } from '@/common/utilities/nojq/_load.thirdparty.scripts.js';

const isSSR = typeof window === 'undefined';

const getRouter = (routes, defaultPath) =>
    createRouter({
        history: (isSSR ? createMemoryHistory : createWebHistory)(defaultPath),
        routes,
    });

const createVueApp = (model = null, appCreator) => {
    if (!isSSR) {
        const glb = window.__INITIAL_STATE__;
        if (glb && glb.enableThirdPart && glb.splits['movoto-enable-debugbear-CW-4406'] === 'on') {
            loadDebugBear();
        }
    }

    const store = createStore();
    const router = initializeRouter(getRouter, model);

    const app = appCreator({
        router,
        render: () => h(App),
    });

    app.provide('$eventBus', $eventBus);
    app.use(router);
    app.use(store);

    molang.install(app, store);
    initialFilters.install(app);
    app.config.globalProperties.isSSR = isSSR;

    app.mixin(compNameMixin);
    app.mixin(urlMixin);
    app.mixin(vnumberMixin);
    // https://stackoverflow.com/a/64429013
    app.mixin({
        mounted() {
            this.$el.__vue__ = this; // for __vue__ for backwards compatibility.
        },
    });

    return { app, router, store };
};

export function createSSR(model) {
    let app = createVueApp(model, createSSRApp);
    return app;
}
export function createCSR(model) {
    let app = createVueApp(model, createApp);
    return app;
}
